import { Reveal } from "./Reveal";

const STEPS = [
  { n: "01", title: "Counselling & Profile Assessment", desc: "Understand goals, academics and budget to chart the right path." },
  { n: "02", title: "University & Course Selection", desc: "Shortlist programs across the USA, UK, Germany and Latvia that fit your profile." },
  { n: "03", title: "Application & Documentation", desc: "SOPs, LORs, transcripts and applications — prepared and filed with precision." },
  { n: "04", title: "Visa & Pre-Departure", desc: "Visa filing, mock interviews and orientation so you land ready." },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="py-20 lg:py-28 bg-white border-t border-slate-900/10">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-amber-800">04 — How It Works</p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B192C] mt-3 leading-[1.05]">
          Your journey, in four steps
        </h2>
      </Reveal>
      <div className="mt-12 border-t border-slate-900/10">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.06}>
            <div data-testid={`process-step-${i + 1}`}
              className="group grid sm:grid-cols-[120px_1fr_1.2fr] items-baseline gap-3 sm:gap-8 py-8 border-b border-slate-900/10 hover:bg-[#F8FAFC] transition-colors duration-300 px-2 sm:px-4">
              <span className="font-heading text-6xl sm:text-7xl font-bold text-amber-500/40 group-hover:text-amber-500/70 transition-colors duration-300">{s.n}</span>
              <h3 className="font-heading text-xl sm:text-2xl font-semibold text-[#0B192C]">{s.title}</h3>
              <p className="text-sm sm:text-base text-slate-600 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
